const PRIVILEGES = {
  CREATE_FAULT: "CREATE_FAULT",
  FAULT_STATUS: "FAULT_STATUS",
  RFO_REQUEST: "RFO_REQUEST",
  RFO_STATUS: "RFO_STATUS",
  VIEW_CURRENT_BILL: "VIEW_CURRENT_BILL",
  VIEW_BILL_HISTORY: "VIEW_BILL_HISTORY",
  VIEW_USER: "VIEW_USER",
  ADD_USER: "ADD_USER",
  UPDATE_EXTERNAL_USER: "UPDATE_EXTERNAL_USER",
  USAGE_SUMMARY: "USAGE_SUMMARY",
  VIEW_PROTOCOL_REPORT: "VIEW_PROTOCOL_REPORT",
  ASSIGN_PRIVILEGE: "ASSIGN_PRIVILEGE",
  PURCHASE_HISTORY: "PURCHASE_HISTORY",
  DELETE_EXTERNAL_USER: "DELETE_EXTERNAL_USER",
  ADD_EXTRA_DATA: "ADD_EXTRA_DATA",
  CHANGE_CONTACT: "CHANGE_CONTACT",
  DETAILED_REPORT: "DETAILED_REPORT",
  REDEEM_DATA: "REDEEM_DATA",
  CREATE_SERVICE_FAULT: "CREATE_SERVICE_FAULT",
  CREATE_BILLING_FAULT: "CREATE_BILLING_FAULT",
  BILL_DISPUTE_STATUS: "BILL_DISPUTE_STATUS",

  REQUEST_NEW_SERVICE: "REQUEST_NEW_SERVICE",
  SERVICE_REQUEST_HISTORY: "SERVICE_REQUEST_HISTORY",
  PURCHASE_DATA_ADDON: "PURCHASE_DATA_ADDON",
  RELOCATION: "RELOCATION",
  CREATE_MESSAGE: "CREATE_MESSAGE",
  VIEW_INBOX: "VIEW_INBOX",
  PROPOSAL_STATUS: "PROPOSAL_STATUS",
  ORDER_STATUS: "ORDER_STATUS",
  VIEW_NOTIFICATION: "VIEW_NOTIFICATION",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  ASSIGN_ACCOUNTS: "ASSIGN_ACCOUNTS",
  SERVICE_LINEUP_ACCESS: "SERVICE_LINEUP_ACCESS",
};

export default PRIVILEGES;
